/** @file modifierScale: the step multiplier of the held modifier keys (Shift x10, Alt x0.1). */

/** The modifier keys of a keyboard or pointer event. */
export type StepModifiers = { shiftKey: boolean; altKey: boolean };

/** Shift = 10, Alt = 0.1, otherwise 1 (Shift wins when both are held). */
export function modifierScale(m: StepModifiers): number {
  if (m.shiftKey) return 10;
  return m.altKey ? 0.1 : 1;
}
